import JournalEntriesStore from "./JournalEntries.Store";
import { RootStore } from "@intrasync/stores";
import { RouteType } from "types/RouteType";

const journalEntriesRoute: RouteType = {
  name: "Journal Entries",
  path: "/accounting/journal-entries",
  layout: "/app",
  viewportCard: {
    header: {
      title: "Journal Entries",
      enableRefreshButton: true,
      enableBackButton: true,
      color: "primary",
      component: () => import("./JournalEntries.Header"),
    },
    body: {
      component: () => import("./JournalEntries.Body"),
      grayBackground: true,
    },
  },
  group: "Accounting",
  requiresAuth: true,
  requiresAdmin: false,
  requiresPermission: false,
  enableAutoFind: false,
  beforeEnter: async ({ rootStore }: { rootStore: RootStore }) => {
    const jeStore = rootStore.journalEntriesViewStore as JournalEntriesStore;
    await jeStore.loadJournalEntries();
    await jeStore.loadAccounts();
    return true;
  },
  dialogs: [
    {
      name: "createJournalEntry",
      title: "Create Journal Entry",
      component: () => import("./dialogs/CreateJournalEntryDialog.Body"),
      onSubmit: async ({ rootStore }: { rootStore: RootStore }) => {
        const jeStore =
          rootStore.journalEntriesViewStore as JournalEntriesStore;
        await jeStore.saveJournalEntry();
      },
      onSubmitValidation: ({ rootStore }: { rootStore: RootStore }) => {
        const jeStore =
          rootStore.journalEntriesViewStore as JournalEntriesStore;
        // Return true if validation fails (to disable submit button)
        return !jeStore.isJournalEntryValid;
      },
      cancelButton: true,
      height: 700,
    },
    {
      name: "editJournalEntry",
      title: "Edit Journal Entry",
      component: () => import("./dialogs/EditJournalEntryDialog.Body"),
      onSubmit: async ({ rootStore }: { rootStore: RootStore }) => {
        const jeStore =
          rootStore.journalEntriesViewStore as JournalEntriesStore;
        await jeStore.saveJournalEntry();
      },
      onSubmitValidation: ({ rootStore }: { rootStore: RootStore }) => {
        const jeStore =
          rootStore.journalEntriesViewStore as JournalEntriesStore;
        // Return true if validation fails (to disable submit button)
        return !jeStore.isJournalEntryValid;
      },
      cancelButton: true,
      height: 700,
    },
    {
      name: "journalEntryDetails",
      title: "Journal Entry Details",
      component: () => import("./dialogs/JournalEntryDetailsDialog.Body"),
      cancelButton: true,
      height: 650,
    },
  ],
};

export default journalEntriesRoute;
